/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import analytics from "../../analytics/analytics";
import environment from "../../modules/environment";

export default {
    enter(path, query, parent) {
        // Extract the product id from the query params
        const productId = parseInt(query.product_gallery[0], 10);

        // Although there will probably only ever be one image-gallery present this makes sure
        // that we find the one that represents the same product id in the query params.
        const imageGallery = _.find(parent.findComponents("image-gallery"), imageGallery => {
            return imageGallery.options.productId === productId;
        });

        if (!imageGallery) {
            throw new Error(
                "There must be an image-gallery component present to load the fullscreen gallery."
            );
        }

        environment.set({
            pageType: "gallery"
        });

        analytics.pageView();

        // this returns the FullscreenGallery component instance
        return imageGallery.openFullscreenGallery();
    },

    update() {
        console.warn("Update on the fullscreen gallery route - this doesnt really make sense!");
    },

    exit(path, queryParams, fullscreenComponent) {
        fullscreenComponent.close();
    }
};

